export const UpdateUserSettings = 'user/settings/UPDATE'
